module.exports = "images/high_performance_workstations@2x.png";